const emitAddToBasketEvent = (payload) => o_global.eventQBus.emit("ft1.order-core.addToBasket", payload);

export { emitAddToBasketEvent };
